import * as React from 'react';
import {Component, ReactElement} from 'react';
import {SessionEditorToggle as Toggle} from '../toggle/toggle';
import {getLanguage} from '../data';
import './styles.sass';

export interface ISessionEditorFooterProps {
  bottomBarHidden: boolean;
  children?: any;
  running: boolean;
  toggleBottomBar: (state?: boolean) => void;
  language: string;
}

export class SessionEditorFooter extends Component<ISessionEditorFooterProps, any> {
  public render(): ReactElement<{}> {
    const {
      bottomBarHidden,
      children,
      toggleBottomBar,
      language,
    } = this.props;

    return language && getLanguage(language).executable && (
      <div className={'session-editor-footer'}>
        <div className={'session-editor-footer__wrapper'}>
          {children}
        </div>

        {bottomBarHidden && <Toggle onToggle={toggleBottomBar} />}
      </div>
    );
  }

  public componentDidUpdate(): void {
    const {running, bottomBarHidden, toggleBottomBar} = this.props;

    if (running && bottomBarHidden) {
      toggleBottomBar();
    }
  }
}
